export default function isSalesforceTourV2(offer: Tours.V2Offer): boolean | undefined {
  if (!offer) { return }
  return offer.productType === 'direct_tour' || offer.productType === 'partner_tour' || offer.productType === 'ultra_lux_tour'
}
